import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';

import { TypographyModule } from '@zwiloo/frontend/typography/typography.module';
import { SharedModule } from '@zwiloo/frontend/shared/shared.module';
import { EmailSentComponent } from './email-sent/email-sent.component';
import { VerifyComponent } from './verify/verify.component';
import { EmailSentDialogComponent } from './email-sent-dialog/email-sent-dialog.component';

@NgModule({
  declarations: [EmailSentComponent, VerifyComponent, EmailSentDialogComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TypographyModule,
  ],
})
export class VerifyEmailModule {}
